import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

import type { LiteraryDesignUnitVisualData, SlideState } from "../../types.d";
import type { SlideViewMode } from "../slide/slide";

const LITERARY_DESIGN_DEFAULT_WIDTH = 680;

@customElement("bp-literary-design-slide")
export class LiteraryDesignSlide extends LitElement {
  @property()
  data?: LiteraryDesignUnitVisualData;

  @property({ attribute: "excluded-key-paths" })
  excludedKeyPaths?: string;

  @property({ attribute: "hide-title" })
  hideTitle?: boolean;

  @property()
  slideState?: SlideState;

  @property({ attribute: "title-wraps-2-lines" })
  titleWraps2Lines?: boolean;

  @property({ attribute: "view-mode" })
  viewMode?: SlideViewMode = "default";

  render() {
    if (!this.data) return;

    const { usx } = this.data;

    return html`
      <bp-zoomable-slide
        ?hide-title=${this.hideTitle}
        ?title-wraps-2-lines=${this.titleWraps2Lines}
        view-mode="${this.viewMode}"
        .slideState=${this.slideState}
      >
        <div slot="title">
          <slot name="title"></slot>
        </div>
        <div slot="content" style="width: ${LITERARY_DESIGN_DEFAULT_WIDTH}px">
          <bp-literary-design
            usx="${usx}"
            .excludedKeyPaths=${this.excludedKeyPaths}
          />
        </div>
      </bp-zoomable-slide>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-literary-design-slide": LiteraryDesignSlide;
  }
}
